export default __webpack_public_path__ + "static/media/Blood Summoner.c1954341.jpg";